import React from 'react';
import { getDecimal } from '../global/utils';
import { useStyles } from "../styles/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'

const LineItems = (props) => {
    const balances = props.balances;
    const plans = props.plans;
    const feeAmount = props.feeAmount;
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Typography variant='subtitle2' sx={{...classes.title, marginTop: '1rem', marginBottom: '1rem'}}>
                Paid Items
            </Typography>
            <List sx={{...classes.list, maxHeight: '100%'}} >
                {plans && plans.length > 0 && plans.map((plan) => {
                    return (
                        <>
                            <ListItem alignItems='flex-start' sx={{...classes.listPadding, borderBottom: '1px solid slategrey'}}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid
                                            container
                                            spacing={2}
                                            alignItems="top"
                                            style={{width: '100%'}}
                                        >
                                            <Grid item xs={8}>
                                                {plan.planDescription}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {`${smallScreen ? '' : 'Item Amount: '}${getDecimal(plan.planPaymentAmount)}`}
                                            </Grid>
                                        </Grid>
                                    }
                                />
                            </ListItem>
                        </>
                    );
                })}
            </List>
            <List sx={{...classes.list, maxHeight: '100%'}} >
                {balances && balances.length > 0 && balances.map((balance) => {
                    return (
                        <>
                            <ListItem alignItems='flex-start' sx={{...classes.listPadding, borderBottom: '1px solid slategrey'}}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid
                                            container
                                            spacing={2}
                                            alignItems="top"
                                            style={{width: '100%'}}
                                        >
                                            <Grid item xs={8}>
                                                {balance.description}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {`${smallScreen ? '' : 'Item Amount: '}${getDecimal(balance.balancePaymentAmount)}`}
                                            </Grid>
                                            {balance.partialPaymentFee && balance.partialPaymentFee > 0 &&
                                                <>
                                                    <Grid item xs={2}>&nbsp;</Grid>
                                                    <Grid item xs={10}>
                                                        {`A partial payment fee of ${getDecimal(balance.partialPaymentFee)} has been added`}
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    }
                                />
                            </ListItem>
                        </>
                    );
                })}
                {feeAmount &&
                    <ListItem alignItems='flex-start' sx={classes.listPadding}>
                        <ListItemText
                            sx={classes.listText}
                            primary={
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="top"
                                    style={{width: '100%'}}
                                >
                                    <Grid item xs={8}>
                                        CitePay Fee
                                    </Grid>
                                    <Grid item xs={4}>
                                        {`${smallScreen ? '' : 'Item Amount: '}${getDecimal(feeAmount)}`}
                                    </Grid>
                                </Grid>
                            }
                        />
                    </ListItem>
                }
            </List>
        </>
    );
}

export default LineItems;
